/**
 * Applies a minimum-price rule: returns `minPriceAmount` when extended price is below it.
 *
 * @param {number} extendedPrice - Current line extended amount before this rule.
 * @param {{ minPriceAmount?: number }} rule - Rule containing `minPriceAmount`.
 * @returns {number} The higher of extended price and minimum, or unchanged if `minPriceAmount` is missing.
 */
export default function calculateMinPrice(extendedPrice, rule) {
  const value = rule?.amount;
  if (extendedPrice < value) {
    return value;
  }
  return extendedPrice;
}
